import React from "react";
import styles from "./TextField.module.scss";
import classNames from "classnames";
import imageValid from "../../../assets/img/icons/03-active.svg";
import imageInvalid from "../../../assets/img/icons/alert-triangle-red.svg";
import TooltipComponent from "../Tooltip/Tooltip";

class TextField extends React.Component<any, any> {
  state = {
    focused: false,
    empty: true
  };

  constructor(props: any) {
    super(props);
    this.onFocusHandler = this.onFocusHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onCopyPasteHandler = this.onCopyPasteHandler.bind(this);
  }

  onFocusHandler(event: any) {
    this.props.input.onFocus(event);
    this.setState({focused: true});

    if (this.props.onFocus !== undefined) {
      this.props.onFocus(event);
    }
  }

  onBlurHandler(event: any) {
    this.props.input.onBlur(event);
    this.setState({focused: false});

    if (this.props.onBlur !== undefined) {
      this.props.onBlur(event);
    }
  }

  onChangeHandler(event: any) {
    this.props.input.onChange(event);
    if (event.target.value === undefined || event.target.value.length === 0) {
      this.setState({empty: true});
    } else {
      this.setState({empty: false});
    }

    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  }

  onCopyPasteHandler(event: any) {
    if (this.props.noCopyPaste) {
      event.preventDefault();
      event.nativeEvent.stopImmediatePropagation();
    }
  }

  getStyles() {
    let inputStyles = classNames(styles.TextField, this.props.cssClassName);

    if (this.state.empty) {
      inputStyles = classNames(inputStyles, styles.TextFieldEmpty);
    }

    if (this.state.focused) {
      inputStyles = classNames(inputStyles, styles.TextFieldFocused);
    }

    if (this.props.meta ? (this.props.meta.touched && this.props.meta.error) : false) {
      inputStyles = classNames(inputStyles, styles.TextFieldError);
    }

    if (this.props.disabled) {
      inputStyles = classNames(inputStyles, styles.TextFieldDisabled);
    }

    if (this.props.textVisibility === "no-visible") {
      inputStyles = classNames(inputStyles, styles.LabelInvisible);
    }

    return inputStyles;
  }

  render() {
    let helpErrorText;
    if (this.props.meta && this.props.meta.touched && this.props.meta.error) {
      helpErrorText = <small>{this.props.meta.error}</small>;
    } else if (this.props.helpText) {
      helpErrorText = <small>{this.props.helpText}</small>;
    }

    let isValidIcon;
    if (this.props.meta && this.props.meta.touched && (this.props.valid === true || this.props.valid === false)) {
      isValidIcon = (
        <span
          className={classNames(
            styles.TextFieldIcon,
            (this.props.valid ? styles.TextFieldIsValid : styles.TextFieldIsInvalid))}
        >
          {this.props.valid ?
            <img src={imageValid} alt={"Valid"} />
            :
            <img src={imageInvalid} alt={"Invalid"} />
          }
        </span>
      );
    }

    let isReadOnlyIcon;
    if (this.props.readOnly) {
      isReadOnlyIcon = (
        <span
          className={classNames(
            styles.TextFieldIcon,
            styles.TextFieldIsReadOnly,
            "material-icons-outline"
          )}
        >
          https
        </span>
      );
    }

    return (
      <div className={this.getStyles()}>
            
        <label htmlFor={this.props.id}>{this.props.labelText}
        {this.props.tooltip && <TooltipComponent>{this.props.tooltip}</TooltipComponent>}</label>
          
        <input
          id={this.props.id}
          {...this.props.input}
          {...this.props.rest}
          type="text"
          disabled={this.props.disabled}
          autoComplete={this.props.noCopyPaste ? "off" : "on"}
          onCopy={this.onCopyPasteHandler}
          onPaste={this.onCopyPasteHandler}
          onFocus={this.onFocusHandler}
          onBlur={this.onBlurHandler}
          onChange={this.onChangeHandler}
        />
        {isValidIcon}
        {isReadOnlyIcon}
        {helpErrorText}
      </div>
    );
  }
}

export default TextField;
